module.exports = "/img/sms.png?be66f2c06e6ba148356469ffdbf956ac";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/sms.png
// module id = VgXy
// module chunks = 46